/**
 * Veli–öğrenci yakınlık seçenekleri (Paket 2). Sunucu sözleşmesi: ParentLinkService::RELATIONS.
 * Login "Veli kaydı" görünümü ve süpervizör "Veli ekle" diyaloğu aynı listeyi kullanır.
 *
 * Bilinçli olarak `@/lib/parent/format` (veli paneli) kullanılmaz: o modül `@/components/data-viz`'i
 * çeker; login sayfası paketine grafik kütüphanesi girmesin.
 */

import type { ParentRelation } from '@/types/parent';

export type { ParentRelation };

export const PARENT_RELATIONS: ReadonlyArray<{ value: ParentRelation; label: string }> = [
    { value: 'mother', label: 'Anne' },
    { value: 'father', label: 'Baba' },
    { value: 'guardian', label: 'Vasi' },
    { value: 'other', label: 'Diğer' },
];

/** Sunucu `relation` boşsa da bunu kullanır (ParentRegisterRequest::payload). */
export const DEFAULT_PARENT_RELATION: ParentRelation = 'guardian';
